import React, {FC} from 'react'
import {ServiceRequestModal} from '../../../../../components/ServiceResquests/Modal'
import {FORMS_CATALOG, FormBlockKind} from '../../../../../components/ServiceResquests/Forms'
import {i18n} from '../../../../../translate/i18n'

interface AddComponentModalProps {
  isOpen: boolean
  onAddBlock: (kind: FormBlockKind) => void
  onClose: () => void
}

const AddComponentModal: FC<AddComponentModalProps> = ({isOpen, onAddBlock, onClose}) => {
  if (!isOpen) return null

  return (
    <ServiceRequestModal
      onCloseAction={onClose}
      title={i18n.t('service_requests.add_component_modal')}
      showAlert={false}
    >
      <div className='pt-6 d-grid gap-2'>
        {FORMS_CATALOG.map((meta) => (
          <button
            key={meta.id}
            className='btn btn-sm btn-light d-flex align-items-center text-start'
            onClick={() => {
              onAddBlock(meta.id)
              onClose()
            }}
          >
            {meta.icon && <i className={`${meta.icon} me-2`} />}
            {meta.title}
          </button>
        ))}
      </div>
    </ServiceRequestModal>
  )
}

export {AddComponentModal}
